<template><v-app>
  <div>
    <div class="pa-6">        
      <h2 class="mb-4">Yunex C3 koper koppelrack</h2>

      <KoperKoppelvlakConfig :koperKoppelvlakken=createKoperKoppelvlakArray(koperKoppelvlak) :show-hardware-id="false" :show-delete-button="false" />

      <Testen :tests=koperKoppelvlakTests :data=data current-hardware-id="Koperkoppelvlak"/>

    </div>
  </div>
</v-app></template>

<script>
/**
 *  The KopperKoppelvlak page contains the tests of the koperkoppelvlak configured in the currently selected test session.
 *  component: KoperKopelvlakConfig - summary table of the koperkoppelvlak in the current iwks configuration
 *  component: Testen - displays all the tests with current executionState and metadata
 */
import gql from 'graphql-tag'
import KoperKoppelvlakConfig from '@/components/KoperKoppelvlakConfig.vue'
import Testen from '@/components/Testen.vue'
import util from '@/components/util'

export default {
  name: 'koperKoppelvlak',
  apollo: {
    /**
     *  Subscription on all koperkoppelvlak tests for data used to display in the Testen component
     *  variable: currently selected test session
     *  If the first test (ping test) does not contain data then there is no koperkoppelvlak test.
     */
      $subscribe: {
        subs: {
          query: gql`subscription koperKoppelvlakSubscription($id: String!) {
          testSessionChanged(testSessionId: $id){
            iwksConfiguration { koperKoppelvlak { hostPLC, hostDSO, hostDSZ } },
            tests { id, hardwareId, testType, executions, { id, currentPhaseProgress, state, lastFatClientFeedback } }
          }
          }`,
          variables () {
            // Use vue reactive properties here
            return {
                id: this.testSessionId
            }
          },
          // Result hook
          // Don't forget to destructure `data`
          result ({ data }) {
            if (data.testSessionChanged.tests.filter(test => test.testType == "KOPER_KOPPELVLAK_PLC_PING").length === 0) {
              this.$router.push('/profibustesten'); 
            } else {
              this.data = data;
              this.koperKoppelvlak = data.testSessionChanged.iwksConfiguration.koperKoppelvlak;
            }
          }
        },
      },
      
    },

    data: () => ({
      /**
       *  koperKoppelvlak:  used to store apollo subscription result of the koperkoppelvlak configuration in iwksConfiguration
       *  koperKoppelvlakTests: metadata of the koperkoppelvlak tests
       *  data: used to store apollo subscription result in its entirety 
       */
      koperKoppelvlak: null,

      koperKoppelvlakTests: {
        KOPER_KOPPELVLAK_PLC_PING: util.getTestInformationMap("KOPER_KOPPELVLAK_PLC_PING"),
        KOPER_KOPPELVLAK_DSO_PING: util.getTestInformationMap("KOPER_KOPPELVLAK_DSO_PING"),
        KOPER_KOPPELVLAK_DSZ_PING: util.getTestInformationMap("KOPER_KOPPELVLAK_DSZ_PING")
      },

      data: {},
    }),

  computed: {
      /**
       *  testSessionId: currently selected test session ID. Globally stored in the Vuex store.
       */
      testSessionId() {
        return this.$store.getters.getCurrentTestSessionId;
      }
    },

    methods: {
      /**
       *  vue-prop-data: the component KoperKoppelvlakConfig expects an array. Convert the object to an array of 1 object.
       */
      createKoperKoppelvlakArray(koperKoppelvlak) {
        let koperKoppelvlakken = [];
        koperKoppelvlakken.push(koperKoppelvlak);
        return koperKoppelvlakken;
      }
    },

    components: {
      KoperKoppelvlakConfig,
      Testen,
    }
}
</script>